import React from "react";
import PropTypes from "prop-types";
import RadioItem from "./radioItem";

class RadioItemData {
    constructor(id,defaultChecked,onChange,label,sublabel){
        this.id=id;
        this.defaultChecked= defaultChecked;
        this.onChange= onChange;
        this.label = label;
        this.sublabel = sublabel
    }
}

function RadioGroup(props) {
    return props.radioItemsData.map((radioItemData) => {
        return (
            <RadioItem
                key={radioItemData.id}
                id={radioItemData.id}
                onChange={radioItemData.onChange}
                defaultChecked={radioItemData.defaultChecked}
                label={radioItemData.label}
                horizontal={props.horizontal}
                sublabel= {radioItemData.sublabel}
            />
        );
    });
}

RadioGroup.propTypes = {
    radioItemsData:PropTypes.arrayOf(PropTypes.instanceOf(RadioItemData)),
    horizontal:PropTypes.bool,
};

export { RadioGroup as default, RadioItemData };
